let history = {},
    localStorageKey = 'terracePlannerChangeHistory';

export function init() {
    try {
        history = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    } catch(e) {
        history = {};
    }

}

/**
 * generates a register if name is not yet present
 *
 * @param name String
 */
export function createRegister(name) {
    if(! history.hasOwnProperty(name)) {
        history[name] = [];
    }
}

/**
 * stringifies history and saves it to localStorage
 */
export function persist() {
    try {
        localStorage.setItem(localStorageKey, JSON.stringify(history));
    } catch(e) {

    }

}

/**
 * pushes data to the history
 *
 * @param name String
 * @param data Object
 */
export function push(name, data) {
    createRegister(name);

    history[name].push(data);
    persist();
}

/**
 * returns the last entry for name and removes it from the history
 *
 * @param name String
 * @returns {Object}
 */
export function pop(name) {
    createRegister(name);

    let data =  history[name].pop();
    persist();

    return data;
}

/**
 * returns whether there is one or more entries in the history for name
 *
 * @param name
 * @returns {boolean}
 */
export function hasEntries(name) {
    createRegister(name);

    return 0 < history[name].length;
}

/**
 * clears all entries for name
 *
 * @param name
 */
export function clearHistory(name) {
    history[name] = [];
    persist();
}

/**
 * clears the entire history
 */
export function clearHistoryAll() {
    history = {};
    persist();
}

/*
var terracePlannerChangeHistory = (function (history, localStorageKey) {

    /!**
     * generates a register if name is not yet present
     *
     * @param name String
     *!/
    var createRegister = function (name) {
        if(! history.hasOwnProperty(name)) {
            history[name] = [];
        }
    };

    /!**
     * stringifies history and saves it to localStorage
     *!/
    var persist = function () {
        try {
            localStorage.setItem(localStorageKey, JSON.stringify(history));
        } catch(e) {

        }

    };

    /!**
     * pushes data to the history
     *
     * @param name String
     * @param data Object
     *!/
    var push = function (name, data) {
        createRegister(name);

        history[name].push(data);
        persist();
    };

    /!**
     * returns the last entry for name and removes it from the history
     *
     * @param name String
     * @returns {Object}
     *!/
    var pop = function (name) {
        createRegister(name);

        var data =  history[name].pop();
        persist();

        return data;
    };

    /!**
     * returns whether there is one or more entries in the history for name
     *
     * @param name
     * @returns {boolean}
     *!/
    var hasEntries = function (name) {
        createRegister(name);

        return 0 < history[name].length;
    };

    /!**
     * clears all entries for name
     *
     * @param name
     *!/
    var clear = function (name) {
        history[name] = [];
        persist();
    };

    /!**
     * clears the entire history
     *!/
    var clearAll = function () {
        history = {};
        persist();
    };

    var init = function () {
        try {
            history = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
        } catch(e) {
            history = {};
        }

    };

    return {
        init: init,
        push: push,
        pop: pop,
        hasEntries: hasEntries,
        clear: clear,
        clearAll: clearAll
    };
})({}, 'terracePlannerChangeHistory');*/
